import React, { useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { supabase } from '../lib/supabase'

export default function Layout({ children, profile, navItems, title }) {
  const location = useLocation()
  const navigate = useNavigate()
  const [mobileOpen, setMobileOpen] = useState(false)

  async function handleSignOut() {
    await supabase.auth.signOut()
  }

  return (
    <div style={{ display: 'flex', height: '100vh', overflow: 'hidden', background: 'var(--black)' }}>

      {/* Sidebar */}
      <div style={{
        width: 'var(--sidebar-width)', background: 'var(--dark)', borderRight: '1px solid var(--border)',
        display: 'flex', flexDirection: 'column', flexShrink: 0,
        position: 'fixed', top: 0, left: mobileOpen ? 0 : '-100%', bottom: 0, zIndex: 200,
        transition: 'left 0.3s ease',
        '@media(min-width:768px)': { left: 0 }
      }} className="sidebar">

        {/* Logo */}
        <div style={{ padding: '24px 20px', borderBottom: '1px solid var(--border)' }}>
          <div style={{ fontFamily: 'var(--font-display)', fontSize: 20, letterSpacing: 2, color: 'var(--white)', lineHeight: 1 }}>
            THE <span style={{ color: 'var(--gold)' }}>PLAYER</span><br />OFFICE
          </div>
          <div style={{ fontFamily: 'var(--font-condensed)', fontSize: 10, letterSpacing: 3, textTransform: 'uppercase', color: 'var(--muted)', marginTop: 6 }}>
            {profile?.role === 'admin' ? 'Admin Portal' : 'Athlete Portal'}
          </div>
        </div>

        {/* Nav */}
        <nav style={{ flex: 1, padding: '16px 12px', overflowY: 'auto', display: 'flex', flexDirection: 'column', gap: 4 }}>
          {navItems.map(item => {
            const active = location.pathname === item.path || location.pathname.startsWith(item.path + '/')
            return (
              <button key={item.path} onClick={() => { navigate(item.path); setMobileOpen(false) }}
                style={{
                  display: 'flex', alignItems: 'center', gap: 12, padding: '11px 14px',
                  background: active ? 'var(--gold-dim)' : 'transparent',
                  border: active ? '1px solid rgba(212,169,64,0.3)' : '1px solid transparent',
                  color: active ? 'var(--gold)' : 'var(--light)',
                  fontFamily: 'var(--font-condensed)', fontSize: 13, fontWeight: 700,
                  letterSpacing: 1.5, textTransform: 'uppercase', textAlign: 'left',
                  transition: 'all 0.15s', width: '100%'
                }}
                onMouseEnter={e => { if (!active) e.currentTarget.style.background = 'var(--card)' }}
                onMouseLeave={e => { if (!active) e.currentTarget.style.background = 'transparent' }}
              >
                <span style={{ fontSize: 16 }}>{item.icon}</span>
                {item.label}
              </button>
            )
          })}
        </nav>

        {/* Profile */}
        <div style={{ padding: '16px 20px', borderTop: '1px solid var(--border)' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 12 }}>
            <div style={{
              width: 36, height: 36, background: 'var(--gold)', display: 'flex',
              alignItems: 'center', justifyContent: 'center', fontFamily: 'var(--font-display)',
              fontSize: 16, color: 'var(--black)', flexShrink: 0
            }}>
              {profile?.full_name?.charAt(0) || 'A'}
            </div>
            <div>
              <div style={{ fontSize: 13, fontWeight: 600, color: 'var(--white)', lineHeight: 1.2 }}>
                {profile?.full_name || 'Athlete'}
              </div>
              <div style={{ fontFamily: 'var(--font-condensed)', fontSize: 10, letterSpacing: 2, textTransform: 'uppercase', color: 'var(--gold)', marginTop: 2 }}>
                {profile?.package_tier || 'Build'}
              </div>
            </div>
          </div>
          <button onClick={handleSignOut}
            style={{
              width: '100%', background: 'transparent', border: '1px solid var(--border)',
              color: 'var(--muted)', fontFamily: 'var(--font-condensed)', fontSize: 11,
              fontWeight: 700, letterSpacing: 2, textTransform: 'uppercase', padding: '8px',
              transition: 'all 0.2s'
            }}
            onMouseEnter={e => { e.currentTarget.style.borderColor = 'var(--gold)'; e.currentTarget.style.color = 'var(--gold)' }}
            onMouseLeave={e => { e.currentTarget.style.borderColor = 'var(--border)'; e.currentTarget.style.color = 'var(--muted)' }}
          >
            Sign Out
          </button>
        </div>
      </div>

      {/* Mobile overlay */}
      {mobileOpen && (
        <div onClick={() => setMobileOpen(false)} style={{
          position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.7)', zIndex: 199
        }} />
      )}

      {/* Main content */}
      <div style={{ flex: 1, display: 'flex', flexDirection: 'column', overflow: 'hidden', marginLeft: 0 }} className="main-content">

        {/* Top bar */}
        <div style={{
          height: 'var(--header-height)', background: 'var(--dark)', borderBottom: '1px solid var(--border)',
          display: 'flex', alignItems: 'center', padding: '0 28px', gap: 16, flexShrink: 0
        }}>
          <button onClick={() => setMobileOpen(true)} className="mobile-menu-btn"
            style={{ background: 'none', border: 'none', color: 'var(--white)', fontSize: 22, display: 'none', padding: 4 }}>
            ☰
          </button>
          <div style={{ fontFamily: 'var(--font-display)', fontSize: 22, letterSpacing: 2, color: 'var(--white)' }}>
            {title}
          </div>
          <div style={{ marginLeft: 'auto', fontFamily: 'var(--font-condensed)', fontSize: 12, letterSpacing: 2, color: 'var(--muted)' }}>
            {new Date().toLocaleDateString('en-US', { weekday: 'long', month: 'long', day: 'numeric', year: 'numeric' })}
          </div>
        </div>

        {/* Page content */}
        <div style={{ flex: 1, overflowY: 'auto', padding: '28px' }}>
          {children}
        </div>
      </div>

      <style>{`
        @media (min-width: 768px) {
          .sidebar { left: 0 !important; position: fixed !important; }
          .main-content { margin-left: var(--sidebar-width) !important; }
          .mobile-menu-btn { display: none !important; }
        }
        @media (max-width: 767px) {
          .mobile-menu-btn { display: block !important; }
        }
      `}</style>
    </div>
  )
}
